<script lang="ts">
  import { createEventDispatcher } from 'svelte'

  export let icon: string = ''
  export let iconActive: string = ''
  export let activeBackground: string = '#30333D'
  export let activeColor: string = 'white'
  export let buttonClass: string = ''
  export let active: boolean = false
  export let isHideOnMobile: boolean = false

  const dispatch = createEventDispatcher<{ 'click': void }>()
</script>

<button 
  class:active={active}
  class:is-hide-on-mobile={isHideOnMobile}
  class={buttonClass}
  style:color={active ? activeColor : '#BDBFC4'}
  style:background-color={active ? activeBackground : '#F3F3F4'}
  on:click={() => dispatch('click')}
>
  <i class={active ? iconActive || icon : icon} />
  {#if $$slots.default}
    <span class="text">
      <slot/>
    </span>
  {/if}
</button>

<style lang="scss">
  button {
    font-size: 10px;
    font-weight: 600;
    line-height: 14px;
    border-radius: 30px;
    border: none;
    padding: 6px 12px;
    cursor: pointer;
    text-transform: uppercase;
    display: inline-flex;
    gap: 5.6px;

    i {
      font-size: 12px;

      &::before {
        margin: 0;
        width: 100%;
      }
    }

    @media (max-width: 576px) {
      &.is-hide-on-mobile {
        width: 36px;
        height: 100%;
        position: relative;

        i {
          margin: 0;
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%,-50%);
        }

        span {
          display: none;
        }
      }
    }
  }
</style>